import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DISPLAY_DATE_FORMAT } from '../../../../common/constants/date-config';
import { IconNames } from '../../../../common/constants/icon-names';
import { LatestNotification } from '../../../../store';
import { DirectivesModule } from '../../../../common/directives/directives.module';
import { PipesModule } from '../../../../common/pipes/pipes.module';
import { SvgIconComponent } from '../../../svg-icon/svg-icon.component';
import { DateWithTimezoneComponent } from '../../../timezone/date-with-timezone.component';

@Component({
  selector: 'ui-latest-notification',
  imports: [CommonModule, TranslateModule, DirectivesModule, PipesModule, SvgIconComponent, DateWithTimezoneComponent],
  templateUrl: './latest-notification.component.html',
  styleUrls: ['./latest-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LatestNotificationComponent {
  @Input() latestNotification: LatestNotification;

  // TODO remove after DN/HU implementation
  @Input() isTimezoneAvailable = true;

  dateFormat = DISPLAY_DATE_FORMAT;
  iconNameList = IconNames;
}
